// extracted by mini-css-extract-plugin
module.exports = {"p1ip4f1g":"p1ip4f1g","skeleton-p1ip4f1g":"skeleton-p1ip4f1g"};